import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-match-progress',
  imports: [MatCardModule, MatProgressBarModule],
  templateUrl: './match-progress.component.html',
  styleUrl: './match-progress.component.scss'
})
export class MatchProgressComponent {}
